import {
  BasicButton,
  BasicInput,
  ModalComponent,
  OptionSelect,
  SelectComponent,
} from "Common/Components";
import { useModalMunicipality } from "../../hooks";

export const ModalMunicipality = () => {
  const {
    isEdit,
    isOpenModal,
    setIsOpenModal,
    clearAll,
    formik,
    t,
    departament,
    valueDepartment
  } = useModalMunicipality();

  return (
    <ModalComponent
      modalTitle={
        isEdit ? t("municipality.titleEdit") : t("municipality.titleCreate")
      }
      show={isOpenModal}
      onHide={() => {
        setIsOpenModal(false);
        clearAll();
        formik.resetForm();
      }}
      size="lg"
    >
      <form
        className="mt-3"
        id="signInForm"
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
          return false;
        }}
      >
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">
            <BasicInput
              label={t("municipality.form.labels.code")}
              placeholder={t("municipality.form.placeholders.code")}
              id="code"
              name="code"
              type="text"
              value={formik.values.code}
              isError={!!(formik.touched.code && formik.errors.code)}
              errorMessage={formik.errors.code || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div className="col-span-1">
            <SelectComponent
              label={t("municipality.form.labels.department")}
              placeholder={t("municipality.form.placeholders.department")}
              options={departament || []}
              id="department_id"
              isMulti={false}
              onBlur={formik.handleBlur}
              value={valueDepartment}
              onChange={(option: OptionSelect) => {
                formik.setFieldValue("department_id", option.value);
              }}
              isError={
                !!(formik.touched.department_id && formik.errors.department_id)
              }
              errorMessage={formik.errors.department_id || ""}
            />
          </div>

          <div className="col-span-2">
            <BasicInput
              label={t("municipality.form.labels.description")}
              placeholder={t("municipality.form.placeholders.description")}
              id="description"
              name="description"
              type="text"
              value={formik.values.description}
              isError={
                !!(formik.touched.description && formik.errors.description)
              }
              errorMessage={formik.errors.description || ""}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>

        <div className="flex justify-end mt-4">
          <BasicButton
            type="submit"
            onClick={() => {}}
            disabled={formik.isSubmitting}
          >
            <span className="text-white">
              {isEdit
                ? t("departament.buttons.edit")
                : t("departament.buttons.addbtn")}
            </span>
          </BasicButton>
        </div>
      </form>
    </ModalComponent>
  );
};
